export function SlideGenerator(data, elementPerSlider) {
            
    if(typeof data === 'undefined') {
        return [];
    }

    let slider = []

    let items = [];
    let slideCounter = 0;
    let itemsCounter = 0;
    let elementCounter = 0;

    data.forEach(function(e)  {

        items.push(e)
        itemsCounter++;
        elementCounter++

        if(itemsCounter == elementPerSlider) {
            slider.push( {id: 'slide-' + slideCounter, items: items })
            itemsCounter = 0;
            slideCounter++;
            items = [];
        } else if(elementCounter == data.length) {
            slider.push( {id: 'slide-' + slideCounter, items: items })
        }

    });
    return slider;
};

export function Excerpt(description) {
    return description.substring(0,100) + ' [...]'
};

